import {useState} from 'react';

import {Alert, DialogActions, DialogContent, useTheme} from '@mui/material';
import PropTypes from 'prop-types';
import {FormProvider, useForm} from 'react-hook-form';

import {REPORT_DATASOURCES_AUTHENTICATION_METHODS, REPORT_DATASOURCES_PRIVACY_LEVELS} from '../../../../const';
import useReportParameters from '../../../../hooks/providers/useReportParameters';
import {sourceShape} from '../../../../proptypes-shapes';
import Button from '../../../form/buttons/Button/Button';
import BaseModal from '../../../modal/BaseModal';
import UpdateSourceForm from '../UpdateSourceForm/UpdateSourceForm';

const mapSourceToFormValues = source => ({
  address: source.connection_details ?? '',
  shouldIgnoreConnectionTest: false,
  authenticationMethod: source.authenticationMethod ?? REPORT_DATASOURCES_AUTHENTICATION_METHODS.ANONYMOUS.id,
  privacyLevel: source.privacyLevel ?? REPORT_DATASOURCES_PRIVACY_LEVELS.NONE.id,
  username: '',
  password: '',
  access_token: '',
  key: '',
  token: ''
});

const UpdateSourceModal = ({isOpen, onClose, source}) => {
  const [error, setError] = useState(null);
  const {updateGatewayDatasourceConnection} = useReportParameters();
  const methods = useForm({
    mode: 'all',
    shouldUnregister: true,
    defaultValues: mapSourceToFormValues(source)
  });
  const {formState, handleSubmit} = methods;
  const {isSubmitting} = formState;

  const onSubmit = async values => {
    setError(null);
    const res = await updateGatewayDatasourceConnection(source.id, source.gatewayId, values);
    if (res.success) {
      onClose();
    } else {
      setError(res.data);
    }
    return res.success;
  };

  const theme = useTheme();

  return (
    <BaseModal maxWidth="sm" onClose={onClose} open={isOpen} title="Mise à jour de la source de données" hasCloseIcon>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent sx={{p: 2.5}}>
            {error && (
              <Alert severity="error" sx={{mb: 3, border: `1px solid ${theme.palette.error.main}`}}>
                {error}
              </Alert>
            )}
            <UpdateSourceForm source={source} />
          </DialogContent>
          <DialogActions>
            <Button variant="outlined" size="large" color="primary" autoFocus onClick={onClose}>
              Annuler
            </Button>
            <Button disabled={isSubmitting} type="submit" variant="contained" size="large" color="secondary">
              Mettre à jour
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </BaseModal>
  );
};

UpdateSourceModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  source: sourceShape.isRequired
};

export default UpdateSourceModal;
